import Button from "@mui/material/Button";
import React, { useState } from "react";

import InventoryCategories from "../../components/Inventory/InventoryCategories";
import InventoryContainer from "./InventoryContainer";
import PreInventoryContainer from "./PreInventoryContainer";

const Inventory = () => {
  const [value, setValue] = useState({ selectTab: "" });
  const [isUpdating, setIsUpdating] = useState(false);

  const handleSelect = (type, target, id) => {
    setValue({ ...value, [type]: target, id: id });
  };

  const handleUpdate = async () => {
    try {
      setIsUpdating(true);
      console.log(
        "funcion para actualizar el inventario, <Inventories /> line 17"
      );
      setTimeout(() => {
        setIsUpdating(false);
      }, 2000);
    } catch (error) {
      setIsUpdating(false);
      console.log(error);
    }
  };

  // console.log(value.selectTab)
  return (
    <section className="flex-center px-5">
      <InventoryCategories
        // totalLength={data?.properties?.length}
        onSelect={handleSelect}
        currentTab={value.selectTab}
      />
      <Button
        variant="text"
        color="primary"
        sx={{ margin: 0 }}
        onClick={handleUpdate}
      >
        Actualizar inventario
      </Button>
      {value.selectTab !== "Pre-inventario" ? (
        <InventoryContainer
          selectTab={value.selectTab}
          isUpdating={isUpdating}
        />
      ) : (
        <PreInventoryContainer />
      )}
    </section>
  );
};

export default Inventory;
